module.exports = __webpack_public_path__ + "img/Calendly@2x.ba501c44.png";